import React from "react"

const SiteLinks: React.FC = ({ children }) => (
  <div style={{ marginBottom: `15px`, textAlign: `center` }}>{children}</div>
)

export default SiteLinks
